<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_station_list'
      params>
      <div>
        <span class='left-table'>站点名称：</span>
        <el-input v-model='name' placeholder='请输入站点名称' style='width: 200px;'></el-input>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
        <span class='left-table'>
          <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>增加</el-button>
        </span>
      </div>
    </icare-table>
    <!-- 编辑信息 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' width='70%' @closed='closeDialog'>
      <el-form ref='form' :model='form' :rules='rules' label-width='200px' >
        <!--        <el-form-item :disabled='true' label="代理商ID" :label-width="formLabelWidth">-->
        <!--          <el-input v-model="form.agency_id" disabled  placeholder="请输入代理商ID"></el-input>-->
        <!--        </el-form-item>-->
        <el-row :gutter='24'>
          <el-col :span='12'>
            <el-form-item label='站点名称' :label-width='formLabelWidth' prop='name'>
              <el-input v-model='form.name'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='收费方式' :label-width='formLabelWidth' prop='charge_type' >
              <el-select v-model='form.charge_type' placeholder='请选择' style='width:100%;'>
                <el-option
                  v-for='item in chargeTypeList'
                  :key='item.value'
                  :label='item.label'
                  :value='item.value'
                ></el-option>
              </el-select>
            </el-form-item>

          </el-col>
        </el-row>

        <el-row :gutter='24'>
          <el-col :span='12'>

            <el-form-item label='收费标准' :label-width='formLabelWidth' prop='charge_type_id' >
              <el-select v-model='form.charge_type_id'  placeholder='请选择' style='width: 100%;'>
                <el-option
                  v-for='item in time_standard_options'
                  :key='item.id'
                  :label='item.time_standard_name'
                  :value='item.id'>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='充电参数' :label-width='formLabelWidth' prop='current_limit_id' >
              <el-select v-model='form.current_limit_id'  placeholder='请选择' style='width: 100%;'>
                <el-option
                  v-for='item in current_limit_options'
                  :key='item.id'
                  :label='item.name'
                  :value='item.id'>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter='24'>
          <el-col :span='12'>
            <el-form-item label='省份' :label-width='formLabelWidth' prop='province'>
              <el-input v-model='form.province'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='市/县' :label-width='formLabelWidth' prop='city'>
              <el-input v-model='form.city'></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter='24'>
          <el-col :span='12'>
            <el-form-item label='区/乡' :label-width='formLabelWidth' prop='district'>
              <el-input v-model='form.district'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='街道' :label-width='formLabelWidth' prop='street'>
              <el-input v-model='form.street'></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label='详细地址' :label-width='formLabelWidth' prop='addr' >
          <el-input v-model='form.addr' ></el-input>
        </el-form-item>
        <el-row :gutter='20'>
          <el-col :span='20'>
            <el-form-item label='站点描述' :label-width='formLabelWidth'>
              <editor :curValue="form.desc" @input="onEditorChange" />
            </el-form-item>

          </el-col>
        </el-row>

        <el-row :gutter='20'>
          <el-col :span='8'>
            <el-form-item label='经度' :label-width='formLabelWidth'>
              <el-input-number v-model='form.longitude' :precision='6' controls-position='right'
                               style='width: 100%;'></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label='纬度' :label-width='formLabelWidth'>
              <el-input-number v-model='form.latitude' :precision='6' controls-position='right'
                               style='width: 100%;'></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>


        <div style='margin-left: 30px;margin-top: 20px;'>
          <!--        <el-row :gutter="20">-->
          <!--          <el-col :span="6">-->
          <!--          <el-input-->
          <!--            placeholder="请输入你要定位的地址(然后点击地图就能定位)"-->
          <!--            v-model="address">-->
          <!--            <i slot="prefix" class="el-input__icon el-icon-search"></i>-->
          <!--          </el-input>-->
          <!--          </el-col>-->
          <!--          <el-col :span="4">-->
          <!--            <el-button type="primary" @click="searchMap()">清空地址栏</el-button>-->
          <!--          </el-col>-->
          <!--        </el-row>-->
          <el-row :gutter='24'>
            <el-col :span='24'>
              <div class='amap-page-container'>
                <br />
                <span style='color: red'> 鼠标点击地图某点，获取您要的经纬度 </span>

                <el-amap
                  vid='amapDemo1'
                  :center='center'
                  :zoom='zoom'
                  class='amap-demo'
                  :events='events'>

                  <el-amap-marker v-for='(marker, index) in markers' :key='marker.index' :position='marker.position'
                                  :icon='marker.icon' :title='marker.title' :events='marker.events'
                                  :visible='marker.visible'
                                  :draggable='marker.draggable' :vid='index'></el-amap-marker>

                </el-amap>
                <div class='toolbar'>
                  <br />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>





      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='closeDialog'>取 消</el-button>
        <el-button type='primary' @click='save'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { getCookie } from '@/utils/auth'
import Tinymce from '@/components/tinymce/index'

export default {

  components:{
    'editor': Tinymce
  },
  data() {
    let self = this
    return {
      loading: false,
      name: '',
      tableParams: {
        id: null,
        name: null
      },
      chargeTypeList: [
        {
          value: 'TIME',
          label: '按时长收费'
        },
        // {
        //   value: 'POWER',
        //   label: '按功率收费'
        // }
      ],
      titleConfig: [
        {
          field: 'name',
          title: '站点名称',
          visible: true
        },
        // {
        //   field: 'charge_type_id',
        //   title: '收费ID',
        //   visible: true
        // },

        {
          field: 'province',
          title: '省份',
          visible: true
        },
        {
          field: 'city',
          title: '市/县',
          visible: true
        },
        {
          field: 'district',
          title: '区/乡',
          visible: true
        },
        {
          field: 'street',
          title: '街道',
          visible: true
        },
        {
          field: 'addr',
          title: '详细地址',
          visible: true
        },
        {
          field: 'longitude',
          title: '经度',
          visible: true,
          fuc: val => {
            return (val).toFixed(6)
          }
        },
        {
          field: 'latitude',
          title: '纬度',
          visible: true,
          fuc: val => {
            return (val).toFixed(6)
          }
        },
        {
          field: 'charge_type',
          title: '收费方式',
          visible: true,
          fuc: val => {
            let text = this.chargeTypeList.filter(obj => obj.value == val)
            return text[0].label
          }
        },
        // {
        //   field: 'base_energy_charge',
        //   title: '基础电费',
        //   visible: true,
        //   fuc: val => {
        //     return (val / 100).toFixed(2) + ' 元/度'
        //   }
        // },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '设备',
              icon: 'el-icon-document',
              color: '#678230',
              fuc: row => {
                this.$router.push({
                  path: '/agencyMgt/monitoring',
                  query: {station_id: row.id}
                })
              }
            },
            {
              title: '编辑',
              color: '#67C23A',
              icon: 'el-icon-edit-outline',
              fuc: this.showEdit
            },
            {
              title: '删除',
              color: '#F56C6C',
              icon: 'el-icon-delete',
              fuc: row => {
                this.delete(row)
              }
            }
          ]
        }
      ],

     //编辑信息
      editTip:'',
      form: {
        id: '',
        base_energy_charge: 0.0
      },
      rules: {
        name: [
          { required: true, message: '请输入站点名称', trigger: 'blur' },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        charge_type_id: [
          { required: true, message: '请输入收费标准', trigger: 'change' }
        ],
        charge_type: [
          { required: true, message: '请输入收费方式', trigger: 'change' }
        ],
        province: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        city: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        district: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        street: [
          { max: 50, message: '输入的文字过长，长度应在 50 个字符内', trigger: 'blur' }
        ],
        addr: [
          { max: 100, message: '输入的文字过长，长度应在 100 个字符内', trigger: 'blur' }
        ]
      },

      formLabelWidth: '100px',
      editVisible: false,
      dialogType: 0,
      time_standard_options: [],
      current_limit_options: [],

      // 点击显示的标记默认的定位
      markers: [/* {
        position: [121.59996, 31.197646]
      } */],

      zoom: 4,
      center: [109.778671, 32.197646],
      address: '',
      province: '',
      city: '',
      district: '',
      lng: '',
      lat: '',
      //  自动定位到当前位置
      plugin: [{
        timeout: 100, //超过10秒后停止定位，默认：无穷大
        panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
        pName: 'Geolocation',
        events: {}
      }],

      events: {
        click(e) {
          let { lng, lat } = e.lnglat
          self.lng = lng
          self.lat = lat

          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })
          self.form.longitude = e.lnglat.lng
          self.form.latitude = e.lnglat.lat

          geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {

                //在地图显示标注
                self.markers = [{
                  position: [e.lnglat.lng, e.lnglat.lat]
                }]

                console.log(result.regeocode)
                // 具体地址
                self.form.addr = result.regeocode.formattedAddress
                console.log(result.regeocode.formattedAddress)
                // 省
                self.form.province = result.regeocode.addressComponent.province
                console.log(result.regeocode.addressComponent.province)
                // 市
                self.form.city = result.regeocode.addressComponent.city
                console.log(result.regeocode.addressComponent.city)
                // 区
                self.form.district = result.regeocode.addressComponent.district
                console.log(result.regeocode.addressComponent.district)
                // 街
                self.form.street = result.regeocode.addressComponent.street
                console.log(result.regeocode.addressComponent.street)

                self.$nextTick()
              }
            } else {
              alert(result)
            }
          })

          // if(self.address.length > 2){
          //   console.log("-----------------------")
          //   geocoder.getLocation(self.address, function (status, res) {
          //     if (status === 'complete' && res.info === 'OK') {
          //         // self.form.longitude=res.geocodes[0].location.lng,
          //         // self.form.latitude=res.geocodes[0].location.lat,
          //         //self.address=self.address
          //       self.markers=[{
          //         position: [res.geocodes[0].location.lng,res.geocodes[0].location.lat],
          //       }]
          //     }else{
          //       self.tishi="您输入的地址无法定位到，请先清空地址栏后用鼠标点击选中!";
          //     }
          //   });
          // }else{
          //   console.log("================")
          //   // self.form.longitude=lng,
          //   //   self.form.latitude=lat,
          //   //   self.markers=[{
          //   //     position: [lng,lat],
          //   //   }]
          // }
        }
      }
    }


  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.getTimeStandard()
    this.getCurrentLimit()
  },
  methods: {
    //弹出编辑(新增)对话框
    showAdd() {
      this.dialogType = 1
      this.editVisible = true
      this.editTip="新增信息"
      this.form = Object.assign({ id: "", agency_id: parseInt(getCookie('agency_id')), base_energy_charge: 0.0 })
    },
    //弹出编辑(新增)对话框
    showEdit(row) {
      this.dialogType = 2
      this.editVisible = true
      this.editTip="编辑信息"
      this.zoom = 4
      this.markers = [{
        position: [row.longitude, row.latitude]
      }]
      row.base_energy_charge = row.base_energy_charge / 100
      this.form = Object.assign({}, row)
    },
    //关闭编辑对话框
    closeDialog() {
      // console.log("closeDialog")
      this.editVisible = false
      this.dialogType = 0
      this.form = {}

      this.$refs['form'].resetFields();
      this.$refs['form'].clearValidate();
    },
    //模糊搜索
    find() {
      this.tableParams.name = this.name
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {


        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_station',
          params: str
        }).then((res) => {
          if(res.code==10004){
            this.$message.warning('删除失败,已被使用')
          }
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let func = 'create_station'

          if (this.dialogType === 2) {

            func = 'set_station'
          }
          let form = Object.assign({}, this.form)
          form.base_energy_charge = form.base_energy_charge * 100
          let str = JSON.stringify(form)
          gateway({
            func: func,
            params: str
          }).then(() => {
            this.closeDialog()
            this.$refs.table.refresh()
          })
        } else {
          return false
        }
      })


    },

    //获取时间收费标准
    getTimeStandard() {
      let str = JSON.stringify({
        id: 0
      })
      gateway({
        func: 'get_time_standard',
        params: str
      }).then(res => {
        this.time_standard_options = res.result
        //this.getData();
      })
    },

    //获取时间收费标准
    getCurrentLimit() {
      let str = JSON.stringify({
        id: 0
      })
      gateway({
        func: 'other_find_current_limit_list',
        params: str
      }).then(res => {
        this.current_limit_options = res.result
      })
    },


    //内容改变事件
    onEditorChange(html) {

      this.form.desc = html
    }



  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

.amap-demo {
  height: 400px;
}
</style>
<style lang='scss' >
.editor {
  line-height: normal !important;
  height: 500px;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>
